import styled, { css } from 'styled-components';

import ButtonLink from '../../UI/ButtonLink/ButtonLink';

export const PhaseWrapper = styled.div<{$backgroundColor?: string;}>` 
  box-shadow: rgba(0, 0, 0, 0.08) 2px 4px 12px 0px;
  border-radius: 16px;
  padding: 12px;
  height: 100px;
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: auto auto auto;
  grid-template-areas: 'mobilist message button';
  ${({ $backgroundColor }) => $backgroundColor && css`background-color: ${$backgroundColor};`}
`;

export const MobilistWrapper = styled.div`
  width: 60px;
  grid-area: mobilist;
  img {
    width: 100%;
    height: auto;
  }
  @media screen and (max-width: 767px) {
    width: 50px;
    height: 50px;
  }
`;

export const MessageBox = styled.div`
  display: flex;
  align-items: flex-end;
  grid-area: message;
`;

export const Message = styled.p`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0 16px;
  @media screen and (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const CTAButton = styled(ButtonLink)`
  margin-left: 10px;
  grid-area: button;
  width: fit-content;
  justify-self: center;
  cursor: pointer;
  transition:
    background-color 0.3s,
    color 0.3s;
  @media screen and (max-width: 767px) {
    margin-left: 0;
  }
`;
